
import React from 'react';

interface MiniSkillBadgeProps {
  rating: number;
  size?: 'sm' | 'xs';
}

export default function MiniSkillBadge({ rating, size = 'sm' }: MiniSkillBadgeProps) {
  const getBadgeColor = () => {
    if (rating >= 7.6) return 'bg-gradient-to-r from-slate-300 to-slate-400';
    if (rating >= 5.1) return 'bg-gradient-to-r from-yellow-300 to-yellow-500';
    if (rating >= 2.6) return 'bg-gradient-to-r from-gray-300 to-gray-400';
    return 'bg-gradient-to-r from-amber-600 to-amber-800';
  };

  const sizeClasses = {
    xs: 'px-2 py-1 min-w-[36px] h-6 text-xs',
    sm: 'px-2.5 py-1.5 min-w-[42px] h-8 text-sm'
  };

  return (
    <div 
      className={`${sizeClasses[size]} rounded-full ${getBadgeColor()} text-white flex items-center justify-center font-bold shadow-sm`}
      title={`Skill Rating: ${rating.toFixed(2)}`}
    >
      {rating.toFixed(2)}
    </div>
  );
}
